import { getCoincard, getSubcard } from '@/api/coinManaging';
import { getGradesOptions } from '@/api/top-up-active';
import { Vue } from 'vue-property-decorator';
/* 价格查询 */
export class PriceQuery extends Vue {
  /* 周期卡家价格 列表 */
  async getSubCardList(client: number = 0) {
    let data: any = [];
    try {
      const res = await getSubcard({ client: client });
      if (res && res.code == 0) {
        data = res.data;
      }
    } catch (error) {
      console.error(error);
    }
    return data;
  }
  /* 云币/桃币价格列表 */
  async getCoinCardList(client: number = 0) {
    let data: any = [];
    try {
      const res = await getCoincard({ client: client });
      if (res && res.code == 0) {
        data = res.data;
      }
    } catch (error) {
      console.error(error);
    }
    return data;
  }

  /**
   * 活动档位列表
   * @param _kind
   */
  async getMarketingGrades(_kind: string, client?: number) {
    let data: any = [];
    try {
      const res = await getGradesOptions({ kind: _kind, out_first_charging: '1', client: client });
      if (res && res.code == 0) {
        data = res.data;
      }
    } catch (error) {
      console.error(error);
    }
    return data;
  }
}
